import { Link } from "react-router-dom";
import { assetUrl } from "../asset-url";

const groups = [
  ["Science", ["/science", "Technologies"], ["/science/umbert-genome-assembly", "UMBERT"], ["/science/direct-molecular-counting", "Molecular Counting"]],
  ["Platform", ["/platform", "Overview"], ["/platform/programmable-life-design-core-ai-engine", "Core AI Engine"], ["/platform/precision-assays", "Precision Assays"]],
  ["Applications", ["/applications", "Overview"], ["/applications/precision-oncology", "Precision Oncology"], ["/applications/industrial-resilience", "Industrial Resilience"]],
  ["Product Line", ["/product-line", "Overview"], ["/product-line/lungdefend", "LungDefend"], ["/product-line/bioweave-buildup-film", "BioWeave"]],
  ["Pipeline", ["/pipeline", "Overview"], ["/pipeline/tolerivex", "Tolerivex"], ["/pipeline/aquila-sentinel", "Aquila Sentinel"]],
  ["Insights", ["/insights", "Overview"], ["/insights/articles", "Articles"], ["/insights/resources", "Resources"], ["/insights/events", "Events"]],
  ["Company", ["/about", "About"], ["/about/story", "Our Story"], ["/about/leadership", "Leadership"], ["/careers", "Careers"], ["/investors", "Investors"], ["/contact", "Contact"]],
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <img src={assetUrl("/assets/medein-logo-light.svg")} alt="Medein" />
          <p>Programmable Life.<br />Precision Science.</p>
        </div>
        <div className="footer-groups">
          {groups.map(([title, ...links]) => (
            <div className="footer-group" key={title}>
              <p>{title}</p>
              {links.map(([path, label]) => (
                <Link to={path} key={path}>{label}</Link>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 Medein. All rights reserved.</p>
        <div>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-of-use">Terms</Link>
          <Link to="/cookie-policy">Cookies</Link>
          <Link to="/sitemap">Sitemap</Link>
        </div>
      </div>
    </footer>
  );
}
